App.controller('ZochLifeInsuranceNotificationCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaLifeInsuranceService', '$timeout', '$stateParams', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaLifeInsuranceService, $timeout, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_insurance'; // @TODO: Change a name of the class if needed;
    $scope.$emit('page', $scope.page);

    $scope.step = 'Zgłoszenie'; 
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.lifeInsurance.details';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.package;
    if (!$scope.data) {
        $state.go('root.home.zoch.lifeInsurance.details');
    }

    $scope.type = 'UNABLE_TO_DEDUCT';

    $scope.send = function() {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        var criteria = {
            id: $scope.stateParams.declaration.declaration.id,
            data: {
                reason: $scope.reason,
                type: $scope.type
            }
        };

        zochaLifeInsuranceService.notify(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.showPopUp('', 'Wiadomość wysłana', 'Zgłoszenie przesłane poprawnie.', 'Przejdź do listy deklaracji', 'root.home.zoch.lifeInsurance.list({"user": null})', 'false');

                $scope.type = 'UNABLE_TO_DEDUCT';
                $scope.reason = '';

                vm.form.$setPristine();
                vm.form.$setUntouched();
                vm.form.$submitted = false;
                // $state.go('root.home.zoch.lifeInsurance.list');
            }
        });
    };

    $scope.showPopUp = function(ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {
            
        }, function() {
            
        });
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];
}]);